<template>
    <div class="optionboard">
        <div
            class="optionboard-header"
            :class="`optionboard-header--${$store.state.selectedPhoneType}`">
            <button
                class="btn-switch"
                @click="switchPhoneType">
                <svg class="btn-switch__icon" width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1995_6501)"><path fill-rule="evenodd" clip-rule="evenodd" d="M14 .93a.75.75 0 011.177-.617l4.432 3.069a.75.75 0 010 1.233l-4.432 3.069A.75.75 0 0114 7.067V5H2a1 1 0 010-2h12V.93zm-9.177 9.383A.75.75 0 016 10.93V13h12a1 1 0 110 2H6v2.067a.75.75 0 01-1.177.617L.391 14.615a.75.75 0 010-1.233l4.432-3.069z" fill="#333"/></g><defs><clipPath id="clip0_1995_6501"><path fill="#fff" d="M0 0h20v18H0z"/></clipPath></defs></svg>
                <span class="btn-switch__text">{{ textBtnSwitch() }}</span>
            </button>
            <div class="diacritic-buttons">
                <button
                    v-if="$store.state.selectedPhoneType == 'vowels'"
                    class="btn-diacritic btn-long"
                    @click="inputDiacriticLong">
                    <span class="btn-diacritic__icon">:</span>
                    <span class="btn-diacritic__text">uzun</span>
                </button>

                <button
                    v-if="$store.state.selectedPhoneType == 'vowels'"
                    class="btn-diacritic btn-shift"
                    @click="inputDiacriticShift">
                    <span class="btn-diacritic__icon">•</span>
                    <span class="btn-diacritic__text">kayma</span>
                </button>

                <button
                    v-if="$store.state.selectedPhoneType == 'consonants'"
                    class="btn-diacritic btn-aspirated"
                    @click="inputDiacriticAspirated">
                    <span class="btn-diacritic__icon">h</span>
                    <span class="btn-diacritic__text">soluklu</span>
                </button>
            </div>
        </div>
        <div class="scroll-wrapper">
            <div
                class="optionboard-phones"
                :class="`optionboard-phones--${$store.state.selectedPhoneType}`">
                <button
                    class="btn-phone"
                    v-for="phone in $store.state.transcriptionPhones[$store.state.selectedPhoneType]"
                    :class="`btn-phone--num-variant-${phone.numVariant}`"
                    @click="inputPhone(phone.valuePhonetic)">
                    <span class="btn-phone__value">[{{ phone.valuePhonetic }}]</span>
                    <span class="btn-phone__label">SESBİRİMCİK</span>
                    <span
                        class="feature"
                        v-for="feature in phone.features">{{ feature }}</span>
                    <div
                        v-if="phone.variant"
                        class="variant">
                        <span class="variant__label">DEĞİŞKE</span>
                        <span class="variant__value">[{{ phone.variant }}]</span>
                    </div>
                </button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        methods: {
            textBtnSwitch(){
                return this.$store.state.selectedPhoneType == 'vowels' ? 'ÜNLÜLER' : 'ÜNSÜZLER';
            },

            switchPhoneType(){
                if(this.$store.state.selectedPhoneType == 'vowels'){
                   this.$store.commit('setSelectedPhoneType', 'consonants');
                }
                else if(this.$store.state.selectedPhoneType == 'consonants'){
                   this.$store.commit('setSelectedPhoneType', 'vowels');
                }
                document.querySelector('.scroll-wrapper').scrollTop = 0;
            },

            inputPhone(valuePhonetic){
                this.$store.commit('setAnswerDataTranscriptionSegmental', valuePhonetic);
                this.$store.state.sfx.transcriptionPhone.currentTime = 0;
                this.$store.state.sfx.transcriptionPhone.play();
            },
            
            inputDiacriticLong(){
                this.$store.commit('setAnswerDataDiacritic', ':');
            },

            inputDiacriticShift(){
                this.$store.commit('setAnswerDataDiacritic', '•');
            },

            inputDiacriticAspirated(){
                this.$store.commit('setAnswerDataDiacritic', 'ʰ');
            }
        }
    };
</script>
<style scoped src="@/css/components/optionboard-phonetic-transcription.css"></style>